var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIconPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.44,
    height: 20.564,
    viewBox: "0 0 17.44 20.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-287.227 -482.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_29",
    "data-name": "\\u30D1\\u30B9 29",
    d: "M312.194,488.983l-6.048-6.048v6.048Z",
    transform: "translate(-10.642 0)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_30",
    "data-name": "\\u30D1\\u30B9 30",
    d: "M301.552,494.262v-5.28H295.5v-6.048h-6.048a1.728,1.728,0,0,0-1.728,1.728v13.825a1.728,1.728,0,0,0,1.728,1.728h6.53",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_31",
    "data-name": "\\u30D1\\u30B9 31",
    d: "M317.052,515.727a3.478,3.478,0,0,0-.422-.028,3.561,3.561,0,1,0,.422.028Zm1.793,2.758-2.625,2.625a.228.228,0,0,1-.323,0l-1.119-1.119-.364-.364a.229.229,0,0,1,0-.323l.323-.323a.229.229,0,0,1,.323,0l.89.889.109.109,2.141-2.14a.229.229,0,0,1,.323,0l.323.323A.228.228,0,0,1,318.845,518.485Z",
    transform: "translate(-15.5 -19.776)",
    fill: "#4477c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20",
    "data-name": "\\u30D1\\u30B9 20",
    d: "M18.8,19.5H12",
    transform: "translate(279.07 472.939)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21",
    "data-name": "\\u30D1\\u30B9 21",
    d: "M18.8,25.5H12",
    transform: "translate(279.07 470.395)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_22",
    "data-name": "\\u30D1\\u30B9 22",
    d: "M13.64,13.5H12",
    transform: "translate(279.138 475.482)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconPage);
export default __webpack_public_path__ + "static/media/nav-icon-page.76c5a8c2191bc03a36520c29d3059b8e.svg";
export { ForwardRef as ReactComponent };